import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
// import classnames from 'classnames';
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
// import CardActions from '@material-ui/core/CardActions';
// import Collapse from '@material-ui/core/Collapse';
import Avatar from "@material-ui/core/Avatar";
// import IconButton from '@material-ui/core/IconButton';
import red from "@material-ui/core/colors/red";
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const styles = theme => ({
  media: {
    height: 0,
    paddingTop: "56.25%" // 16:9
  },
  actions: {
    display: "flex"
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(180deg)"
  },
  avatar: {
    backgroundColor: red[500]
  }
});

class RecipeReviewCard extends React.Component {
  state = { expanded: false };

  handleExpandClick = () => {
    this.setState(state => ({ expanded: !state.expanded }));
  };

  render() {
    const {
      // classes,
      info
    } = this.props;
    // console.log(info.explanation);
    // console.log(post.explanation)
    return (
      <Card className={" post-cards"}>
        <CardHeader
          avatar={
            <Avatar aria-label="Recipe" className={" post-avatar"}>
              اطلاعات بازار
            </Avatar>
          }
          title={
            <span className="ims-title">
              <span className="ims-date">
                <span className="ims-content-data">
                  {info.date_shamsi.substring(0, info.date_shamsi.length - 8)}
                </span>
              </span>
            </span>
          }
          className="ims-card-header"
        />
        <CardContent>
          <div className="ims-prices">
            <p>
              قیمت
              <span className="ims-price-content imcatone">
                {info.imcat2.imcat1.name}
              </span>
              <span className="ims-price-content">{info.imcat2.name}</span>
              <span className="ims-price-price">{info.price}</span>
            </p>
            <p>
              تغییر
              <span className="ims-price-price">{info.price_change_value}</span>
              تومان (
              <span className="ims-price-price">
                {info.price_change_percent}
              </span>
              درصد)
              <span className="ims-price-price">{info.status.name}</span>
              {info.explanation !== null &&
                info.explanation.split(/\r?\n/g).map((t, i) => (
                  <span key={i}>
                    {t}
                    <br />
                  </span>
                ))}
            </p>
          </div>
        </CardContent>
      </Card>
    );
  }
}

RecipeReviewCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(RecipeReviewCard);
